<template>
    <div class="classify">
        <div class="left">
          <div :class="['left-tags', currentIndex == 0 ? 'active' : '']" @click="tagClick(0,-1)">全部</div>
        </div>
        <div class="right">
          <div 
          :class="['right-tags', currentIndex == index + 1 ? 'active' : '']" 
          v-for="(item, index) in classifyInfo" :key="index"
          @click="tagClick(index+1,item.value)"
          >{{ item.name }}</div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Classify',
    props: {
        classifyInfo:{ 
            type:Array,
            required:true
        }
    },
    data(){
      return {
        currentIndex:0
      }
    },
    methods:{
      tagClick(index,value){
        this.currentIndex = index
        this.$emit('tagClick',value)
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
 
 .classify {
      display: flex;
      margin-bottom: 14px;

      .left {
        width: 70px;
        .left-tags {
          width: 40px;
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          background-color: transparent;
          color: #000;
          cursor: pointer;

          &:hover {
            font-weight: bold;
          }
        }

      }

      .right {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        font-weight: 400;
        color: #000;
        cursor: pointer;
        background-color: transparent;

        .right-tags {
          margin-right: 20px;
          margin-bottom: 12px;
          height: 24px;
          line-height: 24px;
          padding: 0 10px;

          &:hover {
            font-weight: bold;
          }
        }
      }

      .active {
        background-color: rgba(0, 0, 0, .08) !important;
      }

    }
  </style>
  